import React, { useEffect, useContext } from "react";
import { Box, Divider,  Snackbar, IconButton, Select, MenuItem } from "@mui/material";
import { fetchToken } from '../auth/Token';
import { Button } from '@mui/material';
import AuthContext from "../auth/AuthProvider";
import { api } from '../api'
import { useState } from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { DataGrid, GridToolbar} from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import  CloseIcon  from '@mui/icons-material/Close';


const AccountActions = ({params}) =>{
    const [open, setOpen] = useState(false);
    const {  permissions } = useContext(AuthContext);
    const [sharesData, setSharesData] = useState({
        "id": params.row.id,
        "account_name": params.row.account_name,
        "share_value": params.row.share_value,
        "interest_amt": params.row.interest_amt,
        "in_out": params.row.in_out,
        "in_ex": params.row.in_ex,
        "as_li": params.row.as_li,
    })
    
    const [ope, setOpe] = React.useState(false);
    const [message, setMessage] = useState("");

    const handleClo = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpe(false);
    };

    const actio = (
        <React.Fragment>
          <Button color="secondary" size="small" onClick={handleClo}>
            CLOSE
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClo}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );


      const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        if (type === 'checkbox') {
            setSharesData({
                ...sharesData,
                [name]: checked,
            });
        } else {
            setSharesData({
                ...sharesData,
                [name]: value,
            });
        }
    };

    const createShares = async (event) => {
        event.preventDefault();
        try {
             await api.post('/account/share', sharesData, {
                headers: {
                    Authorization: 'Bearer '+ fetchToken()
                }
             }).then(function (response) {
                    setMessage(response.data)
                    setOpe(true)
                    setSharesData({
                        "id": params.row.id,
                        "account_name": params.row.account_name,
                        "share_value": params.row.share_value,
                        "interest_amt": params.row.interest_amt,
                        "in_out": params.row.in_out,
                        "in_ex": params.row.in_ex,
                        "as_li": params.row.as_li,
                    })
                    setOpen(false);

             })
        } catch(error) {
            console.log(error)
        }
    }

    const handleOpen = () =>{
        if (permissions && permissions.update_share_account === true){
            setOpen(true)
        }else{
            setMessage("Not Authorized")
            setOpe(true)
        }
    };

    return(
        <>
        <IconButton onClick={handleOpen}><EditIcon /></IconButton>
        <Dialog open={open} onClose={()=>setOpen(false)}>
            <DialogTitle>Edit Shares Account</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Changes might take a couple of minutes to activate
                after the setup.
            </DialogContentText>
            <TextField
                required
                margin="dense"
                id="account_name"
                name="account_name"
                label="Account Name"
                onChange={handleInputChange}
                value={sharesData.account_name}
                type="text"
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="interest_amt"
                name="interest_amt"
                type="number"
                value={sharesData.interest_amt}
                label="Interest Percentage (%)"
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
            />
            

            <TextField
                required
                margin="dense"
                id="share_value"
                name="share_value"
                label="Shares Value"
                onChange={handleInputChange}
                type="number"
                value={sharesData.application_fee}
                fullWidth
                variant="outlined"
            /> 

<Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Inflow/Outflow"
                  id="in_out"
                  label="Inflow/Outflow"
                  value={sharesData.in_out}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_out"
                >
                    <MenuItem value={'inflow'}>
                      Inflow
                    </MenuItem>
                    <MenuItem value={'outflow'}>
                      Outflow
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Income/Expenditure"
                  id="in_ex"
                  label="Income/Expenditure"
                  value={sharesData.in_ex}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_ex"
                >
                    <MenuItem value={'income'}>
                      Income
                    </MenuItem>
                    <MenuItem value={'expenditure'}>
                      Expenditure
                    </MenuItem>
                    <MenuItem value={'stock'}>
                      Stock
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Asset/Liability"
                  id="as_li"
                  label="Asset/Liability"
                  value={sharesData.as_li}
                  onChange={handleInputChange}
                  fullWidth
                  name="as_li"
                >
                    <MenuItem value={'asset'}>
                      Asset
                    </MenuItem>
                    <MenuItem value={'liability'}>
                      Liability
                    </MenuItem>
                </Select>
            
            </DialogContent>
            <DialogActions>
            <Button onClick={()=>setOpen(false)}>Cancel</Button>
            <Button onClick={createShares}>Save Changes</Button>
            </DialogActions>
        </Dialog>
        <Snackbar
            open={ope}
            autoHideDuration={1000}
            onClose={handleClo}
            message={message}
            action={actio}
        />
        </>
    )
};


const ShareAccounts = () => {
    const [allShares, setAllShares] = useState([]);
    const [open, setOpen] = useState(false); 
    const {  permissions } = useContext(AuthContext);
    const [sharesData, setSharesData] = useState({
        "account_name": '',
        "share_value": null,
        "interest_amt": null,
        "in_out": "",
        "in_ex": "",
        "as_li": "",
    })
    const [ope, setOpe] = useState(false);
    const [message, setMessage] = useState("");

      const handleClo = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpe(false);
    };

    const actio = (
        <React.Fragment>
          <Button color="secondary" size="small" onClick={handleClo}>
            CLOSE
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClo}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );
    

    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = () => {
        setOpen(false);
      };

    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        if (type === 'checkbox') {
            setSharesData({
                ...sharesData,
                [name]: checked,
            });
        } else {
            setSharesData({
                ...sharesData,
                [name]: value,
            });
        }
    };

    
const getSharesAccount = async () => {
            try {
              await api.get("/account/share/hh", {
                headers :{
                  Authorization: 'Bearer '+ fetchToken()
                }
              }).then(function (response) {
                  setAllShares(response.data);
              }); 

            } catch (error) {
              console.log(error);
            }
          }


    useEffect(() => {
        
          getSharesAccount();
    }, [])


    const loansColumns = [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "account_name",
            headerName: "Account Name",
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "interest_amt",
            headerName: "Interest Percentage (%)",
            flex: 1,
        },
        {
            field: "in_out",
            headerName: "Inflow/Outflow",
            flex: 1,
          },
          {
            field: "in_ex",
            headerName: "Inflow/Expenditure",
            flex: 1,
          },
          {
            field: "as_li",
            headerName: "Asset/Liability",
            flex: 1,
          },
        {
            field: "share_value",
            headerName: "Share value (%)",
            flex: 1,
        },
        {
            field: "update",
            type:'action',
            headerName: "Action",
            flex: 1,
            renderCell: (params) => <AccountActions {...{params}} />
        },
    ];

    const createShares = async (event) => {
        event.preventDefault();
        try {
             await api.post('/account/share', sharesData, {
                headers: {
                    Authorization: 'Bearer '+ fetchToken()
                }
             }).then(function (response) {
                    setMessage(response.data)
                    setOpe(true)
                    setSharesData({
                        "account_name": '',
                        "share_value": null,
                        "interest_amt": null,
                        "in_out": "",
                        "in_ex": "",
                        "as_li": "",
                    })
                    setOpen(false);
                    getSharesAccount();
             })
        } catch(error) {
            console.log(error)
        }
    }

    return(
        <>
                <Card sx={{ minWidth: 280, margin: 4 }}>
                <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    Shares Account
                </Typography>
                {
                    permissions && permissions.create_share_account === true ?
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                        <Button variant="outlined" onClick={handleClickOpen}>Setup Shares Account</Button>
                    </Typography>
                    :
                    null
                }
                    
                </CardContent>
                <CardActions>
                <Button>
                
                </Button>
                </CardActions>
        </Card>
        <Divider variant="middle" />
        <Box
            m="40px 0 0 0"
            height="75vh"
            paddingBottom="35px"
            sx={{ 
                "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: "white",
                },
                }}
        >
            <DataGrid
                rows={allShares}
                columns={loansColumns}
                checkboxSelection
                slots={{ toolbar: GridToolbar}}
            />
        </Box>

        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Setup Shares Account</DialogTitle>
            <DialogContent>
            <DialogContentText>
                You will be able to open {sharesData.account_name} Accounts
                after the setup.
            </DialogContentText>
            <TextField
                required
                margin="dense"
                id="account_name"
                name="account_name"
                label="Account Name"
                onChange={handleInputChange}
                value={sharesData.account_name}
                type="text"
                fullWidth
                variant="outlined"
            />
            <TextField
                required
                margin="dense"
                id="interest_amt"
                name="interest_amt"
                type="number"
                value={sharesData.interest_amt}
                label="Interest Percentage (%)"
                onChange={handleInputChange}
                fullWidth
                variant="outlined"
            />
            

            <TextField
                required
                margin="dense"
                id="share_value"
                name="share_value"
                label="Shares Value"
                onChange={handleInputChange}
                type="number"
                value={sharesData.application_fee}
                fullWidth
                variant="outlined"
            /> 

<Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Inflow/Outflow"
                  id="in_out"
                  label="Inflow/Outflow"
                  value={sharesData.in_out}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_out"
                >
                    <MenuItem value={'inflow'}>
                      Inflow
                    </MenuItem>
                    <MenuItem value={'outflow'}>
                      Outflow
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Income/Expenditure"
                  id="in_ex"
                  label="Income/Expenditure"
                  value={sharesData.in_ex}
                  onChange={handleInputChange}
                  fullWidth
                  name="in_ex"
                >
                    <MenuItem value={'income'}>
                      Income
                    </MenuItem>
                    <MenuItem value={'expenditure'}>
                      Expenditure
                    </MenuItem>
                    <MenuItem value={'stock'}>
                      Stock
                    </MenuItem>
                </Select>
                <Select
                  variant='outlined'
                  size="small"
                  sx={{m:1}}
                  helperText="Asset/Liability"
                  id="as_li"
                  label="Asset/Liability"
                  value={sharesData.as_li}
                  onChange={handleInputChange}
                  fullWidth
                  name="as_li"
                >
                    <MenuItem value={'asset'}>
                      Asset
                    </MenuItem>
                    <MenuItem value={'liability'}>
                      Liability
                    </MenuItem>
                </Select>
            
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={createShares}>Finish</Button>
            </DialogActions>
        </Dialog>
        <Snackbar
            open={ope}
            autoHideDuration={6000}
            onClose={handleClo}
            message={message}
            action={actio}
        />
                </>

    );
}

export default ShareAccounts